import React, { useEffect, useState } from "react";
import { CustomInput } from "../../components/InputFields/CustomInput";
import MyProfileIMG from "../../assets/images/profile-img.png";
import EditIMG from "../../assets/images/edit-icon.png";
import ButtonComponent from "../../components/Buttons/button";
import { useDispatch, useSelector } from "react-redux";
import { editUser, getUserInfo } from "../../redux/actions/userActions";
import { useLocation, useNavigate } from "react-router-dom";
import constants from "../../utils/constants";
import api from "../../services/api";
import {
  hideLoaderAction,
  showLoaderAction,
} from "../../redux/actions/loaderAction";

const WALLET_NETWORKS = constants.networkOptions;

const validateWalletAddress = (address, network) => {
  if (!address) return "";
  const addr = address.trim();
  if (network === "tron") {
    if (!/^T[A-Za-z1-9]{33}$/.test(addr)) {
      return "Tron addresses must start with T and be 34 characters long";
    }
  } else if (network === "ethereum" || network === "polygon") {
    if (!/^0x[a-fA-F0-9]{40}$/.test(addr)) {
      return "Ethereum/Polygon addresses must start with 0x and be 42 characters long";
    }
  }
  return "";
};

const EditProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userDetails } = useSelector((state) => state.user);

  const [data, setData] = useState({
    firstName: (userDetails && userDetails.firstName) || "",
    lastName: (userDetails && userDetails.lastName) || "",
    walletAddress: (userDetails && userDetails.walletAddress) || "",
    profilePicture: (userDetails && userDetails.profilePicture) || "",
  });

  const [wallets, setWallets] = useState([]);
  const [walletErrors, setWalletErrors] = useState({});
  const [confirmWalletOwnership, setConfirmWalletOwnership] = useState(false);
  const [originalWallets, setOriginalWallets] = useState([]);

  useEffect(() => {
    dispatch(getUserInfo());
  }, [dispatch]);

  useEffect(() => {
    if (userDetails) {
      setData({
        firstName: userDetails.firstName || "",
        lastName: userDetails.lastName || "",
        walletAddress: userDetails.walletAddress || "",
        profilePicture: userDetails.profilePicture || "",
      });

      const existingWallets = userDetails.wallets && userDetails.wallets.length > 0
        ? userDetails.wallets
        : WALLET_NETWORKS.map(n => ({ network: n.value, address: userDetails.walletAddress || "" }));

      const mapped = existingWallets.map(w => ({
        network: w.network,
        address: w.address || "",
      }));
      setWallets(mapped);
      setOriginalWallets(mapped.map(w => ({ ...w })));
      setConfirmWalletOwnership(false);
    }
  }, [userDetails]);

  const walletChanged = () => {
    return wallets.some((w, i) => {
      const orig = originalWallets.find(o => o.network === w.network);
      return w.address.trim() !== (orig ? orig.address.trim() : "");
    });
  };

  const updateWallet = (network, address) => {
    setWallets(prev => prev.map(w =>
      w.network === network ? { ...w, address } : w
    ));
    const error = validateWalletAddress(address, network);
    setWalletErrors(prev => ({ ...prev, [network]: error }));
  };

  const updateUser = () => {
    const hasWalletErrors = Object.values(walletErrors).some(e => e && e.length > 0);
    if (hasWalletErrors) return;
    if (walletChanged() && !confirmWalletOwnership) return;

    dispatch(editUser({
      ...data,
      wallets: wallets.filter(w => w.address.trim() !== ""),
    }, navigate));
  };

  const getImage = (el) => {
    var input = document.getElementById("file-input");
    document.getElementById("showImage").hidden = false;
    document.getElementById("showImage").src = URL.createObjectURL(
      input.files[0]
    );
    uploadImage(input.files[0]);
  };

  const uploadImage = async (item) => {
    try {
      dispatch(showLoaderAction());
      const formData = new FormData();
      formData.append("file", item);

      const res = await api(
        "post",
        constants.endPoints.uploadFile,
        formData,
        {}
      );

      if (res.success && res.data) {
        dispatch(hideLoaderAction());
        return setData({ ...data, profilePicture: res.data.image });
      }
    } catch (error) {
      dispatch(hideLoaderAction());
      console.error("Error uploading images:", error);
      throw error;
    }
  };

  return (
    <div className="page-wrapper">
      <div className="page-hero">
        <h1>
          Edit <span className="gradient-accent">Profile</span>
        </h1>
        <p>Update your profile avatar and user details</p>
      </div>

      <div className="contact-form-card" style={{ maxWidth: "600px", margin: "0 auto 3rem" }}>
        <div id="Image" className=" relative flex justify-content-center ">
          <img
            id="showImage"
            style={{ width: "149px", height: "149px" }}
            className="border-circle"
            src={
              data.profilePicture
                ? `${constants.host}/${data.profilePicture}`
                : MyProfileIMG
            }
            alt=""
          />

          <div
            className="image-upload absolute bottom-0"
            style={{ marginLeft: "100px" }}
          >
            <label htmlFor="file-input">
              <img
                style={{ width: "25px", height: "25px" }}
                src={EditIMG}
                alt=""
              />
            </label>
            <input
              id="file-input"
              onChange={getImage}
              name="file-input"
              type="file"
            />
          </div>
        </div>

        <div className="flex flex-wrap mt-3">
          <CustomInput
            label={"First name"}
            value={data.firstName}
            onChange={(e) => setData({ ...data, firstName: e.target.value })}
          />
          <CustomInput
            label={"Last name"}
            value={data.lastName}
            onChange={(e) => setData({ ...data, lastName: e.target.value })}
          />
        </div>

        <div className="mt-3">
          <h4 style={{ marginBottom: "0.75rem", fontSize: "1rem" }}>Wallet Addresses</h4>
          {wallets.map((wallet) => (
            <div key={wallet.network} style={{ marginBottom: "1rem" }}>
              <label style={{ display: "block", marginBottom: "0.25rem", fontSize: "0.85rem", fontWeight: 600, color: "var(--text-secondary)" }}>
                {WALLET_NETWORKS.find(n => n.value === wallet.network)?.name || wallet.network} Address
              </label>
              <CustomInput
                label={""}
                value={wallet.address}
                placeholder={`Enter ${WALLET_NETWORKS.find(n => n.value === wallet.network)?.name || wallet.network} wallet address`}
                onChange={(e) => updateWallet(wallet.network, e.target.value)}
              />
              {walletErrors[wallet.network] && (
                <p style={{ color: "red", fontSize: "0.8rem", marginTop: "0.25rem" }}>
                  {walletErrors[wallet.network]}
                </p>
              )}
            </div>
          ))}
          {walletChanged() && (
            <div style={{ marginTop: "0.75rem", marginBottom: "1rem" }}>
              <label style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem", cursor: "pointer", fontSize: "0.85rem", color: "var(--text-secondary)" }}>
                <input
                  type="checkbox"
                  checked={confirmWalletOwnership}
                  onChange={(e) => setConfirmWalletOwnership(e.target.checked)}
                  style={{ marginTop: "0.15rem", width: "16px", height: "16px", flexShrink: 0 }}
                />
                <span>
                  I confirm that I am the sole owner and authorized operator of the wallet address(es) provided above. I understand that providing a wallet address I do not control may result in the permanent loss of funds, and Tinbox assumes no liability for transactions sent to an incorrect or unauthorized wallet.
                </span>
              </label>
              {!confirmWalletOwnership && (
                <p style={{ color: "red", fontSize: "0.8rem", marginTop: "0.25rem" }}>
                  You must confirm wallet ownership before saving.
                </p>
              )}
            </div>
          )}
        </div>

        <div className="flex mt-5">
          <div className="col-6">
            <ButtonComponent
              label="Cancel"
              className={"col-12 bg-transparent text-primary border-1"}
              onClick={() => navigate("/my-profile")}
            ></ButtonComponent>
          </div>
          <div className="col-6">
            <ButtonComponent
              label={"Save"}
              className={"col-12"}
              onClick={updateUser}
            ></ButtonComponent>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;